/* OsPlanCatalogImagesComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsPlanCatalogImagesRenderer");
const PagingImagesFeed = require("./PagingImagesFeed");

class OsPlanCatalogImagesComponent extends EventEmitter {
    constructor(imageDetailsView) {
        super();
        this._imageDetailsView = imageDetailsView;
        this._gameEditor = imageDetailsView.getGameEditor();
        this._images = imageDetailsView._images;
        this._osPlan = this._gameEditor.getPlan();
        this._key = imageDetailsView.key;
        this._selectedImages = [];
        this._selectedImagesLength = 0;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    shutdown() {
        this._unregisterListeners();
        if (!this._renderer) {
            return Promise.resolve();
        } else {
            return this._renderer
                .shutdown()
                .then(() => {
                    this._renderer = undefined;
                    this._selectedImages = undefined;
                    this._selectedImagesLength = undefined;
                    this._images = undefined;
                    this._imageDetailsView = undefined;
                    this._gameEditor = undefined;
                    this._osPlan = undefined;
                    this._key = undefined;
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get osCatalogDetailsView() {
        return this._osCatalogDetailsView;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    whenModelIsReady() {
        return this.whenSelectedImagesModelIsReady().then((alreadySavedImages) => {
            this._selectedImagesFeed = Object.values(_.get(alreadySavedImages, "cache"));
            this._selectedImages = this._selectedImagesFeed.filter((image) => {
                if (_.get(this._osPlan, "_pristineProperties.imageAssociations." + this._key + ".imageIds", []).includes(_.get(image, "id"))) {
                    return true;
                }
            });
            // this._selectedImages = Object.values(_.get(alreadySavedImages, "cache"));
            this._selectedImagesLength = this._selectedImages.length;
        });
    }

    whenSelectedImagesModelIsReady() {
        if (this._gameEditor._pagingImagesFeed) {
            // if (_.get(this._gameEditor._pagingImagesFeed, "feed.status", false) === "SHUTDOWN") {
            // return Promise.resolve(this._gameEditor._pagingImagesFeed._feedReestablish());
            // } else {
            return Promise.resolve(this._gameEditor._pagingImagesFeed);
            // }
        } else {
            this._gameEditor._pagingImagesFeed = new PagingImagesFeed({
                feedKey: this._gridKey + "_feed",
                activeOrgId: this._gameEditor._activeOrgId,
                entityDef: this._osPlan,
                columnConfig: {},
                filter: {},
                sort: {}
            });
            return this.whenFeedIsReady();
        }
    }

    whenFeedIsReady() {
        return this._gameEditor._pagingImagesFeed.whenFeedReady();
    }

    _reestablishFeed() {
        this._gameEditor._pagingImagesFeed._feedReestablish();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = OsPlanCatalogImagesComponent;
